module.exports = __webpack_public_path__ + "static/media/page2_furba5.12040443.wav";